export const getHintNotificationConfig = () => {
  const chimeEnabled = process.env.REACT_APP_HINT_CHIME !== "false";
  const toastEnabled = process.env.REACT_APP_HINT_TOAST !== "false";
  const cooldownMs = Number(process.env.REACT_APP_HINT_CHIME_COOLDOWN_MS);
  const toastDurationMs = Number(process.env.REACT_APP_HINT_TOAST_DURATION_MS);
  return {
    chimeEnabled,
    toastEnabled,
    cooldownMs: Number.isFinite(cooldownMs) ? Math.max(0, cooldownMs) : 60_000,
    toastDurationMs: Number.isFinite(toastDurationMs)
      ? Math.max(1000, toastDurationMs)
      : 3500,
  };
};

export const getHintChimeVolume = (taskVolume = 0) => {
  const volume = Number(taskVolume);
  if (!Number.isFinite(volume)) return 0;
  return Math.max(0, Math.min(1, volume / 100)) * 0.45;
};
